import React from 'react'
import PropTypes from 'prop-types'
import shortNumber from '../utilities/shortNumber'
import ButtonWithIcon from './ButtonWithIcon'

class Kudos extends React.Component {
	static getDerivedStateFromProps(props, state) {
		// only update on props change (let state changes go through)
		if (props === state.prevProps) {
			return null
		}
		// put kudos in state to allow the ui to be optimistically updated
		const { kudos, kudosCount } = props
		return { kudos, kudosCount, prevProps: props }
	}

	constructor(props) {
		super(props)
		this.state = {}
		this.doKudosSet = this.doKudosSet.bind(this)
	}

	doKudosSet() {
		this.setState((state) => {
			const kudos = !state.kudos
			let kudosCount = state.kudosCount + (kudos ? 1 : -1)
			kudosCount = kudosCount < 0 ? 0 : kudosCount
			this.props.kudosSet(kudos)
			return { kudos, kudosCount }
		})
	}

	render() {
		const showCountKudos = this.props.showCounts && !!(this.state.kudosCount && this.state.kudosCount !== 0)

		return (
			<ButtonWithIcon onClick={this.doKudosSet} smallerButtons={this.props.smallerButtons} iconName={this.state.kudos ? 'redKudos' : 'blackKudos'}>
				{/* https://www.merriam-webster.com/dictionary/kudo#usage-1 */}
				{showCountKudos && this.context.translate('{kudosCount|# Kudo|# Kudos}', { kudosCount: shortNumber(this.state.kudosCount) })}
				{!showCountKudos && this.context.translate('Kudos')}
			</ButtonWithIcon>
		)
	}
}

Kudos.propTypes = {
	smallerButtons: PropTypes.bool,
	showCounts: PropTypes.bool,
	kudos: PropTypes.bool,
	kudosCount: PropTypes.number,
	kudosSet: PropTypes.func.isRequired
}

Kudos.defaultProps = {
	smallerButtons: false,
	showCounts: true,
	kudos: undefined,
	kudosCount: undefined
}

Kudos.contextTypes = {
	translate: PropTypes.func
}

export default Kudos



// WEBPACK FOOTER //
// ./src/components/Kudos.jsx